import * as t from "./types";
import * as actions from "./action";

export const getAboutMicroserviceAction = (
  payload: t.GetAboutMicroserviceRequestType
): t.GetAboutMicroserviceActionType => {
  return {
    type: actions.GET_ABOUT_MICROSERVICE,
    payload,
  };
};

export const getAboutMicroservicesAction = (
  payload: t.GetAboutMicroservicesRequestType
): t.GetAboutMicroservicesActionType => {
  return {
    type: actions.GET_ABOUT_MICROSERVICES,
    payload,
  };
};

export const addAboutMicroserviceAction = (
  payload: t.CreateAboutMicroserviceRequestType
): t.AddAboutMicroserviceActionType => {
  return {
    type: actions.ADD_ABOUT_MICROSERVICE,
    payload,
  };
};

export const modifyAboutMicroserviceAction = (
  payload: t.ModifyAboutMicroserviceRequestType
): t.ModifyAboutMicroserviceActionType => {
  return {
    type: actions.MODIFY_ABOUT_MICROSERVICE,
    payload,
  };
};

export const deleteAboutMicroserviceAction = (
  payload: t.DeleteAboutMicroserviceRequestType
): t.DeleteAboutMicroserviceActionType => {
  return {
    type: actions.DELETE_ABOUT_MICROSERVICE,
    payload,
  };
};
